import { type ActionType } from "../redux/types";
import { UPDATE_VISIBILITY } from "./actions";
import { showRegionBanner } from "./RegionSelectionBanner";

export interface RegionSelectionBannerState {
  isVisible: boolean;
}

const INITIAL_STATE: RegionSelectionBannerState = {
  isVisible: showRegionBanner(),
};

export const regionSelectionBannerReducer = (
  state: RegionSelectionBannerState = INITIAL_STATE,
  action: ActionType<any>
): RegionSelectionBannerState => {
  switch (action.type) {
    case UPDATE_VISIBILITY: {
      return {
        isVisible: action.payload.isVisible,
      };
    }

    default: {
      return state;
    }
  }
};
